import React, { useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Button,
  Stack,
  Grid,
  Chip,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import styles from "./CalendarBooking.module.css";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Kolkata");

const availability = {
  Sunday: [{ start: "17:00", end: "20:30" }],
  Monday: [{ start: "19:00", end: "20:30" }],
  Tuesday: [{ start: "19:00", end: "20:30" }],
  Wednesday: [{ start: "19:00", end: "20:30" }],
  Thursday: [{ start: "19:00", end: "20:30" }],
  Friday: [{ start: "19:00", end: "20:30" }],
  Saturday: [{ start: "19:00", end: "20:30" }],
};

const weekdays = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
];

const generateTimeSlots = (ranges) => {
  const slots = [];

  ranges.forEach(({ start, end }) => {
    let startTime = dayjs(start, "HH:mm");
    const endTime = dayjs(end, "HH:mm");

    while (startTime.isBefore(endTime)) {
      slots.push(startTime.format("HH:mm"));
      startTime = startTime.add(30, "minute");
    }
  });

  return slots;
};

const CalendarBooking = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    date: null,
    time: null,
    message: "",
  });

  const [availableSlots, setAvailableSlots] = useState([]);

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleDateChange = (value) => {
    const dayName = weekdays[value.day()];
    const ranges = availability[dayName] || [];

    const slots = generateTimeSlots(ranges);

    setFormData((prev) => ({ ...prev, date: value, time: null }));
    setAvailableSlots(slots);
  };

  const handleSlotSelect = (slot) => {
    setFormData((prev) => ({
      ...prev,
      time: dayjs(slot, "HH:mm"),
    }));
  };

  const isDateAvailable = (date) => {
    const dayName = weekdays[date.day()];
    return availability[dayName] && availability[dayName].length > 0;
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.email || !formData.date || !formData.time) {
      alert("Please complete all fields before submitting.");
      return;
    }

    console.log("Booking Submitted:", {
      ...formData,
      time: formData.time?.format("HH:mm"),
    });
    alert("Booking submitted! We’ll follow up shortly.");
  };

  return (
    <Box className={styles.bookingSection}>
      <Typography variant="h5" className={styles.heading}>
        Schedule Your Consultation
      </Typography>

      <Box className={styles.formContainer}>
        <Stack spacing={2}>
          {/* Row 1: Name + Email */}
          <TextField
            label="Full Name"
            fullWidth
            value={formData.name}
            onChange={handleChange("name")}
          />
          <TextField
            label="Email or Phone"
            fullWidth
            value={formData.email}
            onChange={handleChange("email")}
          />

          {/* Row 2: Date */}
          <DatePicker
            label="Preferred Date"
            value={formData.date}
            onChange={handleDateChange}
            shouldDisableDate={(date) => !isDateAvailable(date)}
            slotProps={{ textField: { fullWidth: true } }}
          />

          {/* Row 3: Time Slots */}
          {availableSlots.length > 0 && (
            <>
              <Typography variant="subtitle1" mt={1}>
                Available Time Slots (IST):
              </Typography>
              <Grid container spacing={1}>
                {availableSlots.map((slot) => (
                  <Grid item key={slot}>
                    <Chip
                      label={slot}
                      clickable
                      color={
                        formData.time?.format("HH:mm") === slot
                          ? "primary"
                          : "default"
                      }
                      onClick={() => handleSlotSelect(slot)}
                    />
                  </Grid>
                ))}
              </Grid>
            </>
          )}

          {/* Row 4: Notes */}
          <TextField
            label="Any Specific Notes (Optional)"
            fullWidth
            multiline
            rows={3}
            value={formData.message}
            onChange={handleChange("message")}
          />

          {/* Row 5: Submit */}
          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit}
            className={styles.submitBtn}
          >
            Confirm Booking
          </Button>

          {/* Row 6: Fee Note */}
          <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            mt={2}
          >
            ₹199 consultation fee — fully refunded on solar installation.
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default CalendarBooking;
